// extracted by mini-css-extract-plugin
export default {"body":"ErrorPage_body__s86Pc","header":"ErrorPage_header__La4DT","title":"ErrorPage_title__FyfgC","badge":"ErrorPage_badge__ZJbDY","description":"ErrorPage_description__UIiR+"};